// Free vs Premium, side by side.
//
// A comparison table rather than a list of Premium features, because a list
// only answers "what do I get" and leaves "what am I giving up" to the
// imagination — and in caloly's case the honest answer is flattering: the free
// tier is a complete tracker, not a crippled trial. Of every paywall element
// with cross-category evidence behind it, the Free/Pro table is the one that
// shows up consistently among top performers.
//
// Shared by the paywall sheet and the Pro tab so the two can never drift into
// promising different things.
import { useT } from "../lib/i18n";

interface Row {
  key: string;
  /** What the free tier gets — a value, or false for "not included". */
  free: string | false;
}

const ROWS: Row[] = [
  { key: "plan.row_text",     free: "✓" },   // describing a meal is the free tier's logging method
  { key: "plan.row_barcode",  free: "✓" },   // scanner free since 2026-08-07 — the gate moved to details
  { key: "plan.row_tracking", free: "✓" },
  { key: "plan.row_export",   free: "✓" },
  { key: "plan.row_scanlog",  free: false }, // photo & voice — Premium by owner decision
  { key: "plan.row_details",  free: false }, // macro/micro amounts (the moved gate)
  { key: "plan.row_checkin",  free: false },
  { key: "plan.row_stats",    free: false },
  { key: "plan.row_saved",    free: false },
];

export function PlanComparison() {
  const t = useT();
  return (
    <table className="w-full text-sm border-collapse">
      <thead>
        <tr className="text-fg-muted">
          <th className="text-left font-normal pb-2" />
          <th className="font-normal pb-2 w-16 text-center">{t("plan.col_free")}</th>
          <th className="font-medium pb-2 w-20 text-center text-brand">{t("plan.col_premium")}</th>
        </tr>
      </thead>
      <tbody>
        {ROWS.map(({ key, free }, i) => (
          <tr key={key} className={i > 0 ? "border-t border-line" : ""}>
            <td className="py-2 pr-2 text-fg-secondary">{t(key)}</td>
            <td className="py-2 text-center tabular-nums text-fg-muted">
              {free === false ? <span aria-label={t("plan.not_included")}>—</span> : free}
            </td>
            <td className="py-2 text-center text-brand font-medium">✓</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
